import { ApolloClient, ApolloProvider } from '@apollo/client'
import { UserProvider } from 'domain/users/user_provider/user.provider'
import { ComstructApolloCache } from './apollo_cache'

const APOLLO_CLIENT_URI = process.env.VITE_APOLLO_CLIENT_URI ?? ''

/**
 * Provides the Apollo Client to the application
 * @param props
 * @category General
 */
export function ApolloWrapper(props: {
  /** The children to render */
  children: React.ReactNode
  /** The token to use for authorization */
  token?: string
}) {
  const { children, token } = props
  if (!token) return null
  const client = new ApolloClient({
    uri: APOLLO_CLIENT_URI,
    // https://www.apollographql.com/docs/react/pagination/core-api/
    cache: ComstructApolloCache(),
    headers: {
      authorization: `Bearer ${token}`,
    },
  })
  return (
    <ApolloProvider client={client}>
      <UserProvider>{children}</UserProvider>
    </ApolloProvider>
  )
}
